import React, { useRef } from 'react';
import styled from 'styled-components';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import { toast } from 'react-toastify';
//
import colors from 'theme/colors';
import messages from 'constants/messages';

const { onyx, primary, white } = colors;

const Container = styled.div`
  background-color: ${white};
  border-radius: 2px;
  padding: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const LinkContainer = styled.input`
  border: none;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${onyx};
  resize: none;
  width: 90%;

  :focus {
    outline: none;
  }
`;

const IconContainer = styled.div`
  svg {
    fill: ${primary};
  }
`;

interface IUrlShareProps {
  url: string;
}

export default ({ url }: IUrlShareProps) => {
  const linkRef = useRef<HTMLInputElement>(null);

  function addToClipboard() {
    if (!linkRef?.current) {
      return;
    }

    linkRef.current.select();
    navigator.clipboard.writeText(linkRef.current.value);
    toast.success(messages.success.copiedToClipboard, { autoClose: 5000 });
  }

  return (
    <Container>
      <LinkContainer ref={linkRef} value={url} readOnly />
      <IconContainer>
        <CopyIcon id="url-share-icon" onClick={addToClipboard} />
      </IconContainer>
    </Container>
  );
};
